/*
 * Constantes du référentiel des contacts tiers.
 * Les appels passent par this.$api (SDK @batimentb/vadimm-js-api) sur les routes :
 *   /api/tiers, /api/tiers/:pk, /api/tiers-interlocuteurs (voir vadimm-api resources.py)
 */

export const TIERS_RESOURCE = 'tiers'
export const INTERLOCUTEURS_RESOURCE = 'tiers-interlocuteurs'

export const TIERS_TYPES = [
  { value: 'notaire', label: 'Notaire' },
  { value: 'banque', label: 'Banque' },
  { value: 'courtier', label: 'Courtier' },
  { value: 'constructeur', label: 'Constructeur' },
  { value: 'architecte', label: 'Architecte' },
  { value: 'geometre', label: 'Géomètre' },
  { value: 'expert_comptable', label: 'Expert-comptable' },
  { value: 'assureur', label: 'Assureur' },
  { value: 'diagnostiqueur', label: 'Diagnostiqueur' },
  { value: 'bureau_etude', label: 'Bureau d\'étude' },
  { value: 'collectivite', label: 'Collectivité' },
  { value: 'commercialisateur', label: 'Commercialisateur' },
  { value: 'prestataire', label: 'Prestataire' },
  { value: 'autre', label: 'Autre' }
]

export const tiersTypeLabel = value => {
  const type = TIERS_TYPES.find(t => t.value === value)
  return type ? type.label : value
}

// comparaison de noms sans accents ni casse (garde anti-doublon à la création)
export const normalizeTiersName = value => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()
